import { Injectable } from '@angular/core';
import { CanActivate, CanLoad, Router } from '@angular/router';
import { AccountService } from './services/account/account.service';


/**
 * Hides Capitan-internal pages (the Retail mockups) from gym staff.
 */
@Injectable({ providedIn: 'root' })
export class CapitanStaffGuard implements CanActivate, CanLoad {
  constructor(private accountService: AccountService,
              private router: Router) {
  }

  canActivate(): Promise<boolean> {
    return this.check();
  }

  canLoad(): Promise<boolean> {
    return this.check();
  }

  private async check(): Promise<boolean> {
    if (!this.accountService.myAccountInfoIsLoaded()) {
      await this.accountService.loadMyAccountInfo();
    }
    // getMyAccount() is null when the account request failed (logged out,
    // server error); treat that as not staff rather than throwing.
    if (this.accountService.getMyAccount()?.is_capitan_staff) {
      return true;
    }
    this.router.navigate(['/']);
    return false;
  }
}
